export default {
  title: {
    id: 'gift_cards_proposal_title',
    defaultMessage: 'Digital gift card',
  },
}
